import { deleteRequest, get, post } from './_defaults/fetch.js';

export const getAuthtokens = async ({ params, config } = {}) => get('/authtokens', { params, ...config });
export const createApiKey = async ({ data, config } = {}) => post('/authtokens/api-key', data, config);
export const deleteAuthtoken = async ({ id, config } = {}) => deleteRequest(`/authtokens/${id}`, null, config);
